import React, { useContext, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CartContext } from "./CartContext";
import "../css/paysuccess.css";

const PaymentResult = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const isSuccess = searchParams.get("state") === "success";
  const hasClearedCart = useRef(false);

  useEffect(() => {
    if (isSuccess && !hasClearedCart.current) {
      hasClearedCart.current = true;
      clearCart();
    }
  }, [clearCart, isSuccess]);

  return (
    <main className="successDiv">
      <div className="success-container">
        <div className={`modal-content payment-${isSuccess ? "success" : "cancel"}`}>
          <div className="payment-result-icon" aria-hidden="true">
            <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
          </div>
          <h1>{isSuccess ? "Payment successful" : "Payment cancelled"}</h1>
          <p>
            {isSuccess
              ? "Thank you. Your order has been received and is being reviewed."
              : "Your payment was not completed. You can return to checkout and try again."}
          </p>
          <Link className="payment-result-link" to={isSuccess ? "/shop" : "/checkout"}>
            {isSuccess ? "Continue shopping" : "Return to checkout"}
          </Link>
        </div>
      </div>
    </main>
  );
};

export default PaymentResult;
